// components
import { Container } from 'components/Grid';
import { MirandaSecondaryButton } from '@/components/Button/BaseButton';

// styles
import {
  CustomersLogosWrapper,
  Title,
  LogosList,
  LogoCabot,
  LogoHalli,
  LogoAlcoa,
  LogoAmazon,
  Content,
} from './CustomersLogos.styles';

export function CustomersLogos() {
  return (
    <CustomersLogosWrapper>
      <Container>
        <Title>
          These are some of the companies that trust our consistent service,
          <br /> fair rates, and solutions to <br /> navigate any market
          condition.
        </Title>
        <LogosList spaced>
          <LogoCabot
            src={`/images/home/customers/Cabot.svg`}
            alt="CABOT"
            width="152"
            height="66"
          />
          <LogoHalli
            src={`/images/home/customers/Halliburton.svg`}
            alt="Halliburton"
            width="258"
            height="66"
          />
          <LogoAlcoa
            src={`/images/home/customers/Alcoa.svg`}
            alt="ALCOA"
            width="220"
            height="66"
          />
          <LogoAmazon
            src={`/images/home/customers/AmazonFreight.svg`}
            alt="Amazon Freight"
            width="293"
            height="66"
          />
        </LogosList>

        <Content>Customers who move more with less</Content>
        <MirandaSecondaryButton
          as="a"
          href={`https://lp.loadsmart.com/case-studies`}
        >
          Read Case Studies
        </MirandaSecondaryButton>
      </Container>
    </CustomersLogosWrapper>
  );
}
